import { Injectable } from '@angular/core';
import { UserProfileServiceSpa } from 'src/app/generated/services/security/user_profileSpa';
import { UserProfile } from 'src/app/generated/services/security/user_profile';
export { UserProfile } from 'src/app/generated/services/security/user_profile';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private _userProfileService: UserProfileServiceSpa) { }

  getUserProfile() {
    return this._userProfileService.getByToken({ });
  }

  add(userProfile: UserProfile) {
    return this._userProfileService.addUserProfile(userProfile);
  }

  update(userProfile: UserProfile, expectedVersion: number) {
    return this._userProfileService.updateUserProfile({
      profile: userProfile,
      version: expectedVersion
    });
  }
}
